import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface DuplicateCheckRequest {
    url: string;
    group_uuid: string;
}

interface DuplicateCheckResponse {
    is_duplicate: boolean;
    existing_import?: {
        job_id: string;
        meet_name: string;
        total_results: number;
        imported_at: string;
        imported_by: string;
    };
}

type ReturnType = Promise<AxiosResponse<DuplicateCheckResponse>>;

const checkDuplicate = (data: DuplicateCheckRequest): ReturnType => {
    return Request.get('/workouts/track-events/check-duplicate', {
        params: data,
    });
};

export default checkDuplicate;
